import { state as stateConstants, actions } from 'src/constants';
import api from 'src/core/api';

import { getActionType } from './helper';

const {
  IDENTIFIER_TYPE_LIST,
  IDENTIFIER_TYPE_DETAILS,
  IDENTIFIER_TYPE_ITEM
} = stateConstants;

export const getList = (Model) => (payload, meta = {}) => {
  const actionType = getActionType(
    actions.ACTION_GET,
    Model.NAME,
    IDENTIFIER_TYPE_LIST
  );
  const { url, dataPath } = Model.getListConfig(payload);
  const options = { ...api.http.get(), dataPath };

  return api.request(actionType, url, options, meta);
};

export const getDetails = (
  resource,
  identifier = IDENTIFIER_TYPE_DETAILS,
  config
) => (payload, meta = {}) => {
  const apiConfig = config || resource.getDetailsConfig(payload);

  const actionType = getActionType(
    actions.ACTION_GET,
    resource.NAME,
    identifier
  );
  const { url, dataPath } = apiConfig;
  const options = { ...api.http.get(), dataPath };

  return api.request(actionType, url, options, meta);
};

export const deleteResource = (resource) => (payload, meta = {}) => {
  // unfortunately apis don't support delete so post is used to delete
  // send body = data where data = { resourceId : id }
  // Example:
  // - delete a credit card means data = { userCreditCardId: 1 }

  const actionType = getActionType(
    actions.ACTION_DELETE,
    resource.NAME,
    IDENTIFIER_TYPE_ITEM
  );
  const { url } = resource.getDeleteConfig(payload);
  const options = api.http.post(payload);

  return api.request(actionType, url, options, meta);
};

export const createResource = (resource) => (payload, meta = {}) => {
  const actionType = getActionType(
    actions.ACTION_CREATE,
    resource.NAME,
    IDENTIFIER_TYPE_ITEM
  );
  const config = resource.getCreateConfig?.(payload, meta) || meta;
  const options = api.http.post(payload, config.headers);
  const url = meta.url || config.url;

  return api.request(actionType, url, options, meta);
};

export const updateResource = (resource) => (payload, meta = {}) => {
  const actionType = getActionType(
    actions.ACTION_UPDATE,
    resource.NAME,
    IDENTIFIER_TYPE_ITEM
  );
  const config = resource.getUpdateConfig ? resource.getUpdateConfig() : meta;

  const { url, dataPath } = config;
  const options = { ...api.http.post(payload), dataPath };

  return api.request(actionType, url, options, meta);
};
